import { useLingui } from "@lingui/react/macro";
import { AppDialog } from "./AppDialog";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export interface GlobalDebugDialogProps {
  error: string | null;
  onClose: () => void;
}

export function GlobalDebugDialog({ error, onClose }: GlobalDebugDialogProps) {
  const { t } = useLingui();

  return (
    <AppDialog
      open={!!error}
      onOpenChange={onClose}
      title={t`Debug Info`}
      description={t`A backend/server error was detected.`}
      size="md"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="text-(--color-danger-text) whitespace-pre-wrap flex-1">
          {error}
        </div>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label={t`Close error modal`}
          onClick={onClose}
          className="shrink-0"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </AppDialog>
  );
}
